export enum DiscussionsMessagesTypes {
  OPERATOR = 0,
  SYSTEM = 1
}

export enum DiscussionOperatorTypes {
  OPERATOR = 0,
  HELPER = 1
}

export enum DiscussionErrors {
  NO_ACD_SETTING = 'No ACD setting'
}
